import { CasinoAbTestModel } from 'v2/types/AbTestsModels';

export type CasinoAbTestForm = Omit<CasinoAbTestModel, 'id' | 'entityType'>;

export const initialValues: CasinoAbTestForm = {
  name: '',
  description: '',
  adId: '',
  banners: [],
  isActive: false,
  withUniqueUserImpressions: true,
  maxImpressions: 0,
};
